import React, { useState } from "react";
import { Col } from "react-bootstrap";
import Sticky from "react-stickynode";
import UpperPresentation from "./upper-presentation";
import DashboardSingleListAllDetailsTabContainer from "./tabs-container/details-container";
import DashboardSingleListRolesTabContainer from "./tabs-container/roles-container";
import DashboardSingleListShareholdersTabContainer from "./tabs-container/shareholders-container";
import DashboardSingleListAllNotesTabContainer from "./tabs-container/notes-container";
import {
  requestAddNewClient,
  requestRemoveExistingClient,
  requestAddListCompanyResponse,
  changeSingleListModal,
} from "../../../../redux/actions/single-list";
import TabSelector from "../../../library/tab-selector";
import { UpperRow } from "../../../library/upper-row";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import DropdownMenu from "../../../universal/dropdown-menu";
import "./style.scss";
import { withRouter } from "react-router-dom";

const Index = (props) => {
  const dispatch = useDispatch();

  const responses = useSelector((state) => state.singleList.responses);
  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const statusLoading = useSelector(
    (state) => state.singleList.fetchClientCheck.loading
  );
  const clientExists = useSelector(
    (state) => state.singleList.fetchClientCheck.status
  );

  const [alternativeDropdownOpen, setAlternativeDropdownOpen] = useState(false);
  const [responseDropdownOpen, setResponseDropdownOpen] = useState(false);

  const responseLoading = useSelector(
    (state) => state.singleList.fetchListResponses.loading
  );

  const activeCompany = useSelector((state) => state.singleList.activeDisplay);

  const selectionTabs = [
    {
      key: "details",
      title: "Detaljer",
      content: <DashboardSingleListAllDetailsTabContainer />,
    },
    {
      key: "roles",
      title: "Roller",
      content: <DashboardSingleListRolesTabContainer />,
    },
    {
      key: "shareholders",
      title: "Aksjonærer",
      content: <DashboardSingleListShareholdersTabContainer />,
    },
    {
      key: "notes",
      title: "Notater",
      content: <DashboardSingleListAllNotesTabContainer />,
    },
  ];

  const clickCreateClient = () => {
    dispatch(
      requestAddNewClient({ companyId: selectedCompany, info: activeCompany })
    );
  };

  const clickRemoveClient = () => {
    dispatch(
      requestRemoveExistingClient({
        companyId: selectedCompany,
        info: activeCompany,
      })
    );
  };

  const clickAddResponse = (response) => {
    dispatch(
      requestAddListCompanyResponse({
        companyId: selectedCompany,
        response: response,
        listId: props.match.params.id,
        organizationNumber: activeCompany.general.organizationNumber,
      })
    );
  };

  const retrieveSingleResponse = (id) => {
    if (!responseLoading) {
      if (
        responses &&
        responses.some(
          (r) => r.organizationNumber === id && r.response === "Maybe"
        )
      ) {
        return "Svarte kanskje";
      } else if (
        responses &&
        responses.some(
          (r) => r.organizationNumber === id && r.response === "No"
        )
      ) {
        return "Svarte nei";
      } else if (
        responses &&
        responses.some(
          (r) => r.organizationNumber === id && r.response === "Yes"
        )
      ) {
        return "Svarte ja";
      } else if (
        responses &&
        responses.some(
          (r) => r.organizationNumber === id && r.response === "No answer"
        )
      ) {
        return "Svarte ikke";
      } else {
        return "Velg respons";
      }
    }
  };

  const retrieveResponseIcon = (id) => {
    if (responseLoading || statusLoading) {
      return <i className="fas fa-circle-notch loading fa-spin"></i>;
    }
  };

  const renderResponseToggle = () => {
    return (
      <Dropdown.Toggle
        onClick={() => setResponseDropdownOpen(!responseDropdownOpen)}
        disabled={responseLoading || statusLoading ? true : false}
        id="dropdown-filter"
      >
        {retrieveResponseIcon()}{" "}
        {!responseLoading && !statusLoading
          ? retrieveSingleResponse(activeCompany.general.organizationNumber)
          : "Laster inn.."}{" "}
        <i class="fad arrow fa-angle-down"></i>
      </Dropdown.Toggle>
    );
  };

  const renderActionToggle = () => {
    return (
      <Dropdown.Toggle
        onClick={() => setAlternativeDropdownOpen(!alternativeDropdownOpen)}
        disabled={responseLoading || statusLoading ? true : false}
        id="dropdown-filter"
      >
        {retrieveResponseIcon()}{" "}
        {!responseLoading && !statusLoading ? "Legg til som" : "Laster inn.."}{" "}
        <i class="fad arrow fa-angle-down"></i>
      </Dropdown.Toggle>
    );
  };

  const clickAddContact = () => {
    dispatch(changeSingleListModal({ addContactModal: true }));
  };

  const selectResponseOptions = [
    {
      title: "Svarte ja",
      key: "answeryes",
      active:
        retrieveSingleResponse(activeCompany.general.organizationNumber) ===
        "Svarte ja",
      action: () => clickAddResponse("Yes"),
    },
    {
      title: "Svarte nei",
      key: "answerno",
      active:
        retrieveSingleResponse(activeCompany.general.organizationNumber) ===
        "Svarte nei",
      action: () => clickAddResponse("No"),
    },
    {
      title: "Svarte kanskje",
      key: "answermaybe",
      active:
        retrieveSingleResponse(activeCompany.general.organizationNumber) ===
        "Svarte kanskje",
      action: () => clickAddResponse("Maybe"),
    },
    {
      title: "separator",
      key: "separator",
    },
    {
      title: "Fjern respons",
      key: "erase",
      active: null,
      action: () => clickAddResponse("Erase"),
    },
  ];

  const selectActionOptions = [
    {
      title: "Ny kunde",
      key: "answeryes",
      active: clientExists && clientExists === "yes",
      action: () =>
        clientExists && clientExists === "yes"
          ? clickRemoveClient()
          : clickCreateClient(),
    },
    {
      title: "separator",
      key: "separator",
    },
    {
      title: "Kontakt i kontaktliste",
      key: "answerno",
      active:
        retrieveSingleResponse(activeCompany.general.organizationNumber) ===
        "Svarte nei",
      action: () => clickAddContact(),
    },
  ];

  const renderMainButtons = () => {
    return [
      <DropdownMenu
        content="regular"
        type="title"
        color="inverse-blue"
        size="regular"
        spacing="right"
        toggle={renderResponseToggle()}
        title="Velg respons"
        options={selectResponseOptions}
        open={responseDropdownOpen}
        setOpen={setResponseDropdownOpen}
      />,
      <DropdownMenu
        content="regular"
        type="title"
        color="green"
        size="regular"
        spacing="right"
        toggle={renderActionToggle()}
        title="Velg et alternativ"
        options={selectActionOptions}
        open={alternativeDropdownOpen}
        setOpen={setAlternativeDropdownOpen}
      />,
    ];
  };

  return (
    <Col className="dashboard-single-list-right-container parentscroll">
      <Sticky enabled={true} top={100}>
        <Col className="inner-dashboard-single-list-right-container">
          <UpperRow
            manyButtons={true}
            title="Informasjon"
            buttons={renderMainButtons()}
          />
          <UpperPresentation />
          <TabSelector defaultValue="details" items={selectionTabs} />
        </Col>
      </Sticky>
    </Col>
  );
};

export default withRouter(Index);
